import type { UploadedFileType } from '../../../contexts';
import type { CustomFile } from '../file';
import { getUniqueFile } from './get-unique-file';
import { getUniqueFileName } from './get-unique-file-name';
import { isDuplicateFile } from './is-duplicate-file';

const MAX_FILE_SIZE = 100 * Math.pow(2, 20);

export function getNewFileList({
  file,
  fileList,
  checkExtension
}: {
  file: UploadedFileType;
  fileList: CustomFile[];
  checkExtension: (name: string) => boolean;
}): CustomFile[] {
  if (isDuplicateFile(file, fileList)) {
    return fileList;
  }

  const hasUploadError = file.uploaded === 'error_upload';

  const existingFile = fileList.find(({ data }) => data.name === file.name);

  if (hasUploadError && existingFile && !existingFile.uploadError) {
    return fileList.map((fileFromList) =>
      fileFromList.data.name === file.name
        ? { ...fileFromList, uploadError: true }
        : fileFromList
    );
  }

  const uniqueName = getUniqueFileName(file.name, fileList);
  const uniqueFile = getUniqueFile(file, uniqueName);

  const emptyFileError = uniqueFile.size === 0;
  const fileSizeExceededError = uniqueFile.size > MAX_FILE_SIZE;
  const extensionError = checkExtension(uniqueFile.name);

  return [
    ...fileList,
    {
      data: uniqueFile,
      deleted: false,
      emptyFileError,
      fileSizeExceededError,
      extensionError,
      uploadError: false
    }
  ];
}
